export default {"src":"/_next/static/media/pacte-bonne-conduite.f90f6b03.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};